export type GetHelixSearchSessionRes = {
    sessionSummary: HelixSearchSessionSummary
}

export type HelixSearchSessionSummary = {
    sst: string
    status: HelixSearchSessionStatus
    pipelineStage?: string
    roleId?: string
    booleanSearchQuery?: string
    booleanSearchAutoIgnoreRetired?: boolean
    networkSeedPersonIds?: string[]
    booleanSearchEvalPersonCount?: number
    relationshipEvalPersonCount?: number
    // this is the people that exist in both the boolean search and relationship search
    fullyQualifiedPersonCount?: number
    totalUniqueCandidatePoolCount?: number
    expiration?: Date
    createdAt: Date
    updatedAt: Date
}

export enum HelixSearchSessionStatus {
    NOT_STARTED = 'NOT_STARTED',
    RUNNING = 'RUNNING',
    COMPLETE = 'COMPLETE',
    ERROR = 'ERROR',
}
